// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/alerts/alerts.less
// module id = 3611
// module chunks = 0